// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error .error-view .icon svg {\n  max-width: 100%;\n}", "",{"version":3,"sources":["webpack://./src/views/errorNotFound/errorNotFound.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB","sourcesContent":[".error .error-view .icon svg {\n  max-width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
